var map = {
	"./about_bg.jpg": 4543,
	"./background.jpg": 2152,
	"./background_mob.jpg": 1563,
	"./card1.jpg": 1213,
	"./card2.jpg": 1314,
	"./card3.jpg": 3695,
	"./card4.jpg": 8756,
	"./card5.jpg": 6801,
	"./check.svg": 4414,
	"./desk-bg.jpg": 5659,
	"./error.png": 6080,
	"./form1.png": 1573,
	"./form2.png": 1198,
	"./menu-bg.jpg": 8825,
	"./name.png": 9873,
	"./slide1.jpg": 8928,
	"./slide2.jpg": 1919,
	"./slide3.jpg": 5538,
	"./slide4.jpg": 3585,
	"./spiral.png": 5131,
	"./spiral_sphere.png": 1707,
	"./success.png": 5027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;